import React from 'react'

import { SxProps } from '@mui/material'
import { TAccount } from 'types/GlobalAccount'

import { useAccounts } from 'redux/hooks/Accounts'
import { useTranslation } from 'language/translator'

import GenericAvatar from 'components_new/molecules/GenericAvatar'
import IconButton from 'components_new/atoms/IconButton'
import Tooltip from 'components_new/atoms/Tooltip'

import GenericListItem, {
  GenericListItemProps
} from 'components_new/molecules/GenericListItem'
import SearchAndSelectPopover from 'components_new/molecules/SearchAndSelectPopover'

import { formatUsername, getSelectedOption } from 'utils/functions'

interface SelectUserProps {
  disabled?: boolean
  onChange?: (value: string | null) => void
  options?: TAccount[] // if custom set of accounts
  short?: boolean
  size?: GenericListItemProps['size']
  sx?: SxProps
  value: string | null
}

const SelectUser = (props: SelectUserProps) => {
  const { disabled, onChange, options, short, size, sx, value } = props
  const { accounts: allAccounts } = useAccounts()
  const { t } = useTranslation()

  const accounts = options ?? allAccounts
  const selectedAccount = getSelectedOption(value, accounts)

  const title = selectedAccount
    ? formatUsername(selectedAccount)
    : t('global', 'no_owner')

  return (
    <SearchAndSelectPopover
      disabled={disabled}
      key={1}
      multiple={false}
      onChange={onChange}
      options={accounts.map((account) => {
        return {
          avatar: 'user',
          body: account.email,
          id: account.id,
          title: formatUsername(account)
        }
      })}
      sx={sx}
      value={value}
    >
      {short ? (
        <Tooltip title={title}>
          <IconButton
            disabled={disabled}
            size={size === 'xsmall' ? 'small' : size}
          >
            <GenericAvatar
              size={size}
              title={value === null ? undefined : title}
              variant="user"
            />
          </IconButton>
        </Tooltip>
      ) : (
        <GenericListItem
          body={selectedAccount ? selectedAccount.email : undefined}
          disabled={disabled}
          disablePadding={true}
          onClick={disabled ? undefined : () => {}}
          title={title}
          TitleProps={{
            color: !selectedAccount ? 'text.disabled' : undefined
          }}
          size={size}
          sx={{ borderRadius: 1, px: 0.5 }}
          variant="user"
        />
      )}
    </SearchAndSelectPopover>
  )
}

export default SelectUser
